import { FGToast, FGToastIsActive } from '@fg/design-system';

export function notifySearchFailure(
    feedName: 'events' | 'insights' | 'predictions',
    clearSearch: () => void
) {
    const toastId = `${feedName}-search-failed-toast`;
    if (!FGToastIsActive(toastId)) {
        FGToast(
            { content: 'Search failed, please try again.', type: 'error' },
            { autoClose: 5000, position: 'top-right', toastId }
        );
    }
    clearSearch();
}
